import { PolymerElement, html } from '@polymer/polymer';
import { GestureEventListeners } from '@polymer/polymer/lib/mixins/gesture-event-listeners.js';
import { COMCalendarBehavior } from '@com/calendar';
import '@polymer/polymer/polymer-legacy.js';
import './style/com-avl-cal-awakening-calendar-style.js';

import '@polymer/polymer/lib/elements/dom-repeat.js';
import '@polymer/polymer/lib/elements/dom-if.js';

/**
 * `com-avl-cal-awakening-calendar`
 *
 * @customElement
 * @polymer
 * @demo demo/index.html
 */
class COMAvlCalAwakeningCalendar extends COMCalendarBehavior(GestureEventListeners(PolymerElement)) {
    static get template() {
        return html`
            <style include="com-theme"></style>
            <style include="com-avl-cal-awakening-calendar-style"></style>

            <com-calendar
                id="calendarContainer"
                months-to-display="[[monthsToDisplay]]"
                date-type-map="[[dateTypeMap]]"
                aria-content="[[ariaContent]]"
                selected-dates="{{selectedDates}}"
                dates="[[dates]]"
                end-date="[[endDate]]"
                display-strict-num-months="{{displayStrictNumMonths}}"
                current-date="[[currentDate]]"
            >
            </com-calendar>
        `;
    }

    static get is() { return 'com-avl-cal-awakening-calendar'; }

    static get properties() {
        return {
            adaptive: {
                type: String,
                reflectToAttribute: true
            },
            isVariableParks: {
                type: Boolean,
                value: false
            },
            monthsToDisplay: {
                type: Number,
                value: 1
            },
            dateTypeMap: Object,
            dates: Array,
            ariaContent: Object,
            selectedDates: {
                type: Array,
                notify: true
            },
            endDate: {
                type: String,
                value: ''
            },
            displayStrictNumMonths: {
                type: Boolean,
                value: false
            },
            defaultDate: {
                type: String,
                value: ''
            },
            currentDate: {
                type: String,
                value: ''
            }
        };
    }

    static get observers() {
        return [
            '_setCurrentDateValue(selectedDates, defaultDate)'
        ];
    }

    ready() {
        super.ready();
    }

    /**
     * Set the selected date value
     * @param selectedDates
     */
    _setCurrentDateValue(selectedDates, defaultDate) {
        if (!selectedDates && defaultDate) {
            this.currentDate = defaultDate;
            return;
        }

        let selectedDateSaved = sessionStorage.getItem('selectedDate');
        if (!selectedDates && selectedDateSaved) {
            this.currentDate = selectedDateSaved;
            return;
        }

        if(selectedDates && selectedDates.length > 0 && Array.isArray(selectedDates)) {
            this.currentDate = selectedDates[0];
        }
    }

}
customElements.define(COMAvlCalAwakeningCalendar.is, COMAvlCalAwakeningCalendar);
